var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m56.13,38.25h-12.25c-10,0-18.14,8.14-18.14,18.14v34.95c0,1.47,1.19,2.65,2.65,2.65h43.23c1.47,0,2.65-1.19,2.65-2.65v-34.95c0-10-8.14-18.14-18.14-18.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m50.33,31.6c7.05,0,12.79-5.74,12.79-12.79s-5.74-12.79-12.79-12.79-12.79,5.74-12.79,12.79,5.74,12.79,12.79,12.79Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21.52,34.55c6.27,0,11.37-5.1,11.37-11.37s-5.1-11.37-11.37-11.37-11.37,5.1-11.37,11.37,5.1,11.37,11.37,11.37Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m79.04,34.55c6.27,0,11.37-5.1,11.37-11.37s-5.1-11.37-11.37-11.37-11.37,5.1-11.37,11.37,5.1,11.37,11.37,11.37Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m30.16,40.5c-1.83-.62-3.78-.98-5.82-.98h-6.19C8.14,39.52,0,47.66,0,57.66v27.88c0,1.47,1.19,2.65,2.65,2.65h20.21v-31.81c0-6.34,2.83-12.04,7.29-15.89Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m81.86,39.52h-6.19c-2.04,0-3.99.35-5.82.98,4.46,3.85,7.29,9.55,7.29,15.89v31.81h20.21c1.47,0,2.65-1.19,2.65-2.65v-27.88c0-10-8.14-18.14-18.14-18.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.5857127b4ac6333fcb2a484e1c99dece.svg";
export { ForwardRef as ReactComponent };